/**
 * Country Address Format Factory
 *
 * Returns country-specific address format configuration based on country code
 */

import { AU_ADDRESS_FORMAT } from './au';
import { CA_ADDRESS_FORMAT } from './ca';
import { DEFAULT_ADDRESS_FORMAT } from './default';
import { FR_ADDRESS_FORMAT } from './fr';
import { GB_ADDRESS_FORMAT } from './gb';
import { NZ_ADDRESS_FORMAT } from './nz';
import { US_ADDRESS_FORMAT } from './us';

import type { CountryAddressFormat } from './country-types';

/**
 * Get address format for a specific country
 * @param {string} countryCode - ISO 3166-1 alpha-2 country code (e.g., 'US', 'CA')
 * @returns {CountryAddressFormat} Country-specific address format configuration
 */
export const getCountryAddressFormat = (countryCode: string): CountryAddressFormat => {
  switch (countryCode?.toUpperCase()) {
    case 'US':
      return US_ADDRESS_FORMAT;
    case 'CA':
      return CA_ADDRESS_FORMAT;
    case 'AU':
      return AU_ADDRESS_FORMAT;
    case 'GB':
      return GB_ADDRESS_FORMAT;
    case 'FR':
      return FR_ADDRESS_FORMAT;
    case 'NZ':
      return NZ_ADDRESS_FORMAT;
    default:
      return DEFAULT_ADDRESS_FORMAT;
  }
};
